import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.background};
    border-radius: ${theme.radius.default};
    box-shadow: ${theme.shadows.flat};
    padding: 2.4rem;
    margin: 2.4rem 0;
  `}
`;

export const Content = styled.div`
  max-width: 680px;
  display: flex;
  justify-content: flex-start;
`;

export const ContentAddRow = styled(Content)`
  padding-top: 1rem;
  justify-content: flex-end;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem;

  @media (max-width: 1010px) {
    margin: 0 0 2rem 0;
  }
`;

export const LabelContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;

export const Label = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.default};
    color: ${theme.colors.labelInput};
  `}
`;

export const Table = styled.table`
  ${({ theme }) => css`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0 4px;
    background-color: ${theme.colors.lightGrey};
    box-shadow: 1px 1px 6px #ececec;
    border-radius: ${theme.radius.small};

    tr {
      border-radius: ${theme.radius.small};
    }
  `}
`;

export const ItemSequence = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 1rem 0.5rem 1rem 1rem;
    font-size: ${theme.fontSizes.large};
    font-weight: ${theme.weight.strong};
    background-color: ${theme.colors.backgroundContainer};
    border-top-right-radius: ${theme.radius.small};
    border-top-left-radius: ${theme.radius.small};
  `}
`;

export const ItemSequenceLabel = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.weight.veryStrong};
  `}
`;

export const ItemContent = styled.div`
  display: flex;

  @media (max-width: 1010px) {
    flex-direction: column;
  }
`;

export const ItemWrapper = styled.div`
  width: 100%;
  padding: 0 0.5rem 0 0.5rem;
  margin-top: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem;
`;
